import { Button } from "@/components/ui/button"
import { ThemeToggle } from "@/components/theme-toggle"
import { useLocation } from "wouter"
import { FileText, Home, Upload } from "lucide-react"

export function Header() {
  const [location, setLocation] = useLocation()

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-14 items-center justify-between">
        <div className="flex items-center space-x-4">
          <Button
            variant="ghost"
            onClick={() => setLocation('/')}
            className="flex items-center space-x-2"
            data-testid="button-home-nav"
          >
            <FileText className="h-5 w-5" />
            <span className="font-semibold">Lease Analyzer</span>
          </Button>
        </div>

        <nav className="flex items-center space-x-4">
          <Button
            variant={location === '/' ? 'default' : 'ghost'}
            size="sm"
            onClick={() => setLocation('/')}
            data-testid="button-nav-home"
          >
            <Home className="h-4 w-4 mr-2" />
            Home
          </Button>
          <Button
            variant={location === '/upload' ? 'default' : 'ghost'}
            size="sm"
            onClick={() => setLocation('/upload')}
            data-testid="button-nav-upload"
          >
            <Upload className="h-4 w-4 mr-2" />
            Upload
          </Button>
          <ThemeToggle />
        </nav>
      </div>
    </header>
  )
}